import { render, staticRenderFns } from "./importNoticeRead.vue?vue&type=template&id=967a9ee8"
import script from "./importNoticeRead.vue?vue&type=script&lang=js"
export * from "./importNoticeRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports